var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LexieButton } from '@/components/lexie-button.component';
import { List, ListItemText, styled, Typography } from '@mui/material';
export var HearingAidCard = function (_a) {
    var hearingAid = _a.hearingAid, onClick = _a.onClick;
    var Root = styled('div')(function (_a) {
        var theme = _a.theme;
        return ({
            display: 'grid',
            boxShadow: theme.shadows[2],
            borderRadius: '1.5rem',
            padding: '1.5rem',
            gap: '1rem',
        });
    });
    var Header = styled('div')({
        display: 'grid',
        justifyContent: 'start',
        gap: '0.5rem',
    });
    var Body = styled('div')({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    });
    var Footer = styled('div')({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    });
    return (_jsxs(Root, { children: [_jsxs(Header, { children: [hearingAid.headerImage, _jsx(Typography, __assign({ variant: "h6" }, { children: hearingAid.name }))] }), _jsxs(Body, { children: [_jsx(List, __assign({ dense: true }, { children: hearingAid.description.map(function (description, index) { return (_jsx(ListItemText, { primary: description }, "".concat(hearingAid.name, "-desc-").concat(index))); }) })), typeof hearingAid.image === 'string' ? (_jsx("img", { src: hearingAid.image, alt: hearingAid.name })) : (hearingAid.image)] }), _jsxs(Footer, { children: [_jsx(Typography, __assign({ className: "mx-0", variant: "subhead-bold" }, { children: hearingAid.price })), _jsx(LexieButton, __assign({ size: "small", variant: "contained", onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(hearingAid); } }, { children: _jsx(Typography, __assign({ variant: "small", color: "inherit" }, { children: "View product" })) }))] })] }));
};
